export const FILE_MODERATION_STATUSES = [
    'approved',
    'rejected',
    'failed',
    'non-moderated'
];
export const FILE_UPLOAD_STATUSES = ['pending', 'failed', 'completed'];
export const isIFileAttachment = (attachment) => typeof attachment === 'object' &&
    attachment !== null &&
    'fileKey' in attachment &&
    'fileName' in attachment;
export class FileViewerState {
    files = [];
    currentIndex = 0;
    isOpen = false;
    previousFile() {
        if (this.files.length <= 1)
            return;
        if (this.currentIndex > 0) {
            this.currentIndex--;
        }
        else {
            this.currentIndex = this.files.length - 1;
        }
    }
    nextFile() {
        if (this.files.length <= 1)
            return;
        if (this.currentIndex < this.files.length - 1) {
            this.currentIndex++;
        }
        else {
            this.currentIndex = 0;
        }
    }
    toggleIsOpen() {
        this.isOpen = !this.isOpen;
    }
}
export const MEGA_BYTE = 1024 * 1024;
export const MAX_FILE_SIZE = 30 * MEGA_BYTE;
export const ALLOWED_MIMES = new Set([
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'image/heic',
    'image/heif',
    'image/avif',
    'audio/mpeg',
    'audio/wav',
    'audio/mp4',
    'audio/aac',
    'audio/aiff',
    'video/mp4',
    'video/quicktime',
    'video/x-msvideo',
    'video/webm',
    'video/x-m4v'
]);
export const ALLOWED_EXTS = new Set([
    'jpg',
    'jpeg',
    'png',
    'webp',
    'heic',
    'heif',
    'apng',
    'avif',
    'mp3',
    'wav',
    'm4a',
    'aac',
    'aiff',
    'mp4',
    'mov',
    'avi',
    'webm',
    'm4v',
    '3gp'
]);
// Optional: fallback mapping ext -> mime for presign if sniff fails
export const EXT_TO_MIME = {
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    png: 'image/png',
    webp: 'image/webp',
    heic: 'image/heic',
    heif: 'image/heif',
    apng: 'image/png',
    avif: 'image/avif',
    mp3: 'audio/mpeg',
    wav: 'audio/wav',
    m4a: 'audio/mp4',
    aac: 'audio/aac',
    aiff: 'audio/aiff',
    mp4: 'video/mp4',
    m4v: 'video/mp4',
    '3gp': 'video/mp4',
    mov: 'video/quicktime',
    avi: 'video/x-msvideo',
    webm: 'video/webm'
};
//# sourceMappingURL=fileAttachment.js.map